<template>
    <ac-modal :title="'Switch Dashboards'" ref="modal">
        <template>
            <div class="row">
                <div class="col-md-6 switch-dash-container" v-for="d in dashboards" style="cursor: pointer" @click.prevent="()=>switchDashboard(d)">
                    <div style="text-align: center">
                        <i :class="getClass(d)" class="wl-color"></i>
                    </div>
                    <div style="text-align: center">
                        <h3>{{ d.dashboard }}</h3>
                        <h4>{{ d.entityName }}</h4>
                    </div>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "../../global/framework/api.js";

    export default {
        name: "MultipleRolesModal",
        data() {
            return {
                dashboards: []
            };
        },
        methods: {
            async showModal() {
                this.dashboards = await api.getNoId("Account", "GetAssociatedDashboards");
                this.$refs.modal.open();
            },
            switchDashboard({associatedRoleName, entityId}) {
                this.$refs.modal.close();
                window.location.href = "/" + associatedRoleName.toLowerCase() + "/#/" + entityId + "/dashboard";
            },
            getClass(dashboard) {
                let css = ['fa', 'fa-3x'];
                if (dashboard.associatedRoleName.toLowerCase() == "consumer") {
                    css.push('fa-user');
                } else if (dashboard.associatedRoleName.toLowerCase() == "company") {
                    css.push('fa-building');
                } else {
                    css.push('fa-dashboard');
                }
                return css;
            }
        }
    }
</script>

<style scoped>
    .switch-dash-container {
        font-size: 12.5px;
    }

    .switch-dash-container h3 {
        font-size: 24px;
        margin: 10px 0 10px 0;
        font-weight: normal;
    }

    .switch-dash-container h4 {
        font-size: 18px;
        font-weight: normal;
    }
</style>